<template>
  <!-- 水波纹点击效果按钮 -->
  <el-button
    class="zt-button"
    :class="{'no-fill': noFill}"
    :type="type"
    v-waves="waves && type != 'text'"
    v-bind="$attrs"
    v-on="$listeners"
    :loading="loading"
    :style="styles"
  >
    <slot name="loading" v-if="loading"><slot></slot></slot>
    <slot v-else></slot>
  </el-button>
</template>

<script>
import waves from '@/directive/waves/index.js' // 水波纹指令
export default {
  directives: { waves },
  props: {
    loading: Boolean,
    // 按钮类型
    type: {
      type: String,
    },
    // 是否使用水波纹
    waves: {
      type: Boolean,
      default: true
    },
    // 是否默认状态是否填充
    noFill: {
      type: Boolean,
      default: false
    },
    // 宽度
    minWidth: String,
    maxWidth: String,
    width: String,
  },
  computed: {
    styles() {
      const {minWidth, maxWidth, width} = this
      return {minWidth, maxWidth, width}
    }
  }
}
</script>

<style lang="scss" scoped>
.el-button + .el-button {
  margin-left: 0;
}

@import './button.scss';

// 默认状态不填充
// .el-button.no-fill:not(:hover):not(:focus):not(:active){
//   background-color: transparent;
// }

// 自定义type 样式
.el-button--diy {
  @include button-variant(white,pink,white)
}

</style>